import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Utilities} from '@shared/utilities/utilities.model';
import {ImpactPointTypes} from '@shared/enums/impact-point-types.enum';
import {VehicleNature} from '../../../claims/claims-commons/models/vehicle.model';

@Component({
    selector: 'amd-external-impact-point',
    templateUrl: './external-impact-point.component.html',
    styleUrls: ['./external-impact-point.component.scss']
})
export class ExternalImpactPointComponent implements OnInit, OnChanges {

    @Input() nature: VehicleNature;
    @Input() impactPoints: ImpactPointTypes[] = [];
    @Input() canEdit = true;
    @Output() onPointsChange: EventEmitter<ImpactPointTypes[]> = new EventEmitter();

    impactPointType = ImpactPointTypes;

    vehicleNature = VehicleNature;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.nature && !changes.nature.firstChange) {
            this.impactPoints = [];
            this.onPointsChange.emit(this.impactPoints);
        }
    }

    setPoint(impactPoint) {
        if (!this.canEdit) {
            return;
        }
        if (this.impactPoints && !this.impactPoints.find(point => point === impactPoint)) {
            this.impactPoints.push(impactPoint);
        }
        this.onPointsChange.emit(this.impactPoints);
    }

    clearPoint(impactPoint) {
        const index = this.impactPoints.indexOf(impactPoint);
        if (index >= 0) {
            this.impactPoints = [...this.impactPoints.filter(point => point !== impactPoint)];
            this.onPointsChange.emit(this.impactPoints);
        }
    }

    isActive(impactPoint) {
        if (Utilities.isVoid(this.impactPoints)) {
            return false
        }
        return this.impactPoints && this.impactPoints.find(point => point === impactPoint);
    }

    hasMiddleSelected() {
        return this.impactPoints && this.impactPoints.find(point => point === this.impactPointType.SIDE_FRONT_R || point === this.impactPointType.SIDE_FRONT_L);
    }
}
